import React from 'react';
import { motion } from 'framer-motion';
const UseCaseItem = ({
  title,
  description,
  index
}: {
  title: string;
  description: string;
  index: number;
}) => <motion.div initial={{
  opacity: 0,
  y: 20
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true
}} transition={{
  duration: 0.5,
  delay: index * 0.1
}} className="border-l-2 border-gray-200 pl-4 sm:pl-6 py-2 hover:border-orange-500 transition-colors" data-id="element-1206">
    <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2" data-id="element-1207">
      {title}
    </h3>
    <p className="text-base sm:text-lg text-gray-600 leading-relaxed" data-id="element-1208">
      {description}
    </p>
  </motion.div>;
const UseCasesNarrative = () => {
  return <section className="w-full bg-white py-16 sm:py-24 md:py-32 lg:py-48" data-id="element-1209">
      <div className="container mx-auto px-4 sm:px-6 md:px-8" data-id="element-1210">
        <div className="max-w-4xl mx-auto" data-id="element-1211">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-10 sm:mb-12 md:mb-16 tracking-tight leading-tight" data-id="element-1212">
            What teams are building with FluidWeb
          </motion.h2>

          <div className="grid md:grid-cols-2 gap-8 sm:gap-10 md:gap-12 lg:gap-16" data-id="element-1213">
            <UseCaseItem index={0} title="AI-powered ERPs" description="Finance teams onboard vendors, run reports, and update records without navigating complex screens." data-id="element-1214" />
            <UseCaseItem index={1} title="AI-first CRMs" description="Sales reps say 'add follow-up for Acme' and it's done — with permissions and logging." data-id="element-1215" />
            <UseCaseItem index={2} title="Internal tools" description="Ops teams query databases and take actions on tickets, shipments, or orders using natural language." data-id="element-1216" />
            <UseCaseItem index={3} title="Vertical SaaS copilots" description="Specialized, bounded agents for real estate, legal, healthcare, and logistics that execute domain workflows safely." data-id="element-1217" />
          </div>
        </div>
      </div>
    </section>;
};
export default UseCasesNarrative;